import Price from "JS/components/price/Price.vue";
import Vue from 'vue';
import { BlogCategories, BlogTagGroups } from 'Src/js/services/BlogService';
import { createListSlider } from "JS/list-slider";
import { initializeBlogCarousel } from 'Src/js/utilities/blog';
import { onWindowResize } from "../utilities/viewport";

//Pet Category Page
initializeBlogCarousel('#petBlogCarousel', {
	title: 'Pet Care Tips from The Animal Experts',
	smallTitle: 'Pet Care Blogs',
	viewAllLink: 'https://www.farmandfleet.com/blog/?s=&tag=cats,dogs,small-animals',
	viewAllLinkAssistiveText: 'Pet Care Blog Posts',
	query: {
		categories: [BlogCategories.Pets],
		tags: BlogTagGroups.HousePets,
		perPage: 8,
	}
});

//Dog Category Page
initializeBlogCarousel('#dogBlogCarousel', {
	title: 'Dog Care Tips from The Animal Experts',
	smallTitle: 'Dog Care Tips',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/dogs/',
	viewAllLinkAssistiveText: 'Dog Care Blog Posts',
	query: {
		tags: BlogTagGroups.Dogs,
		perPage: 8,
	}
});

//Cat Category Page
initializeBlogCarousel('#catBlogCarousel', {
	title: 'Cat Care Tips from The Animal Experts',
	smallTitle: 'Cat Care Tips',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/cats/',
	viewAllLinkAssistiveText: 'Cat Care Blog Posts',
	query: {
		tags: BlogTagGroups.Cats,
		perPage: 8,
	}
});

const priceRoots: NodeListOf<HTMLElement> = document.querySelectorAll("[data-product]");
for (const el of priceRoots) {
	if (!el.dataset.product) continue;

	const productIn = JSON.parse(el.dataset.product);
	new Vue({
		el,
		render: h => h(Price, {
			props: {
				price: productIn.price,
				showGetQuote: productIn.showGetQuote,
				showInStoreOnlyMessage: productIn.showInStoreOnlyMessage,
				isComingSoon: productIn.isComingSoon,
			}
		})
	});
}

const carousels: NodeListOf<HTMLElement> = document.querySelectorAll(".styled-widget-carousel");
for (let i = 0; i < carousels.length; i++) {
	const viewport: HTMLElement | null = carousels[i].querySelector('[data-list-slider-viewport]');

	if (viewport) {
		const listSlider = createListSlider(viewport);
		listSlider.setControls(carousels[i].querySelector(".carousel__button-back"), carousels[i].querySelector(".carousel__button-forward"));
		onWindowResize(() => listSlider.reset());
	}
}


//Toggle second row of circle card view more button.
window.addEventListener('DOMContentLoaded', function () {
	const viewMoreButton = document.getElementById("viewMoreButton");

	if (!viewMoreButton) return;

	const circleCardWrapper = document.getElementsByClassName("circle-card__wrapper")[0];
	let prevTextContent: string | null = "Show Less";
	const toggleClass = "open";

	if (viewMoreButton) {
		viewMoreButton.onclick = function () {
			circleCardWrapper.classList.toggle(toggleClass);

			const temp = viewMoreButton.textContent;
			viewMoreButton.textContent = prevTextContent;
			prevTextContent = temp;

			if (viewMoreButton.getAttribute("aria-expanded") === "true") {
				viewMoreButton.setAttribute("aria-label", "Show More Brands");
				viewMoreButton.setAttribute("aria-expanded", "false");
			} else {
				viewMoreButton.setAttribute("aria-expanded", "true");
				viewMoreButton.setAttribute("aria-label", "Show Fewer Brands");
			}
		};
	}
});

//Toggle hidden categories on the Hero.
window.addEventListener('DOMContentLoaded', function () {
	const viewAllButton = document.getElementById("heroWidgetViewAll");

	if (!viewAllButton) return;

	const heroElement = document.getElementsByClassName("hero-widget")[0];
	const toggleClass = "hero-widget--open";

	viewAllButton.onclick = function () {
		heroElement.classList.toggle(toggleClass);

		if (viewAllButton.getAttribute("aria-expanded") === "true") {
			viewAllButton.setAttribute("aria-label", "View All Categories");
			viewAllButton.setAttribute("aria-expanded", "false");
		} else {
			viewAllButton.setAttribute("aria-expanded", "true");
			viewAllButton.setAttribute("aria-label", "View Less Categories");
		}
	};
});
